






























































import {
  defineComponent,
  PropType,
  toRef,
  ref,
  onMounted,
  onUpdated,
  onBeforeUnmount,
  nextTick,
  computed,
} from "@nuxtjs/composition-api";
import Glide from "@glidejs/glide";
import type { Product } from "@wemade-vsf/catalog/lib/runtime/product/types";
import { useProductGallery } from "@wemade-vsf/catalog/lib/runtime/product/composables/useProductGallery";
import { SfGallery, SfButton } from "@storefront-ui/vue";
import ProductLabels from "components/catalog/Product/ProductLabels.vue";

export default defineComponent({
  name: "ProductGallery",
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    filter: {
      type: String,
      default: "",
    },
    current: {
      type: Number,
      default: 1,
    },
  },
  components: {
    SfGallery,
    SfButton,
    ProductLabels,
  },
  setup(props, { emit }) {
    const product = toRef(props, "product");
    const { productGallery, imageSizes } = useProductGallery(product);
    const activeIndex = ref(props.current - 1);
    const sliderOptions = computed(() => {
      return {
        type: "slider",
        autoplay: false,
        rewind: false,
        gap: 0,
        perView: 1,
        startAt: activeIndex.value,
      };
    });

    const selectedPicture = ref(
      productGallery.value?.[0] || {
        alt: "",
        zoom: "",
        big: { url: "" },
        desktop: "",
      }
    );
    const videoItems = computed(() =>
      productGallery.value
        ? productGallery.value.filter((p) => p.video && p.video.video_url)
        : []
    );
    const imageItems = computed(() =>
      productGallery.value
        ? productGallery.value.filter((p) => !p.video || !p.video.video_url)
        : []
    );

    const glideEl = ref(null);
    const galleryImgEl = ref(null);
    const glide = ref(null);

    const go = (index) => {
      selectedPicture.value = productGallery.value[index];
      if (!glide.value) return;
      activeIndex.value = index;
      emit("move", index + 1);
      glide.value.go(`=${index}`);
    };

    onMounted(() => {
      emit("init", {
        numImages: imageItems.value.length,
        numVideos: videoItems.value.length,
      });
      nextTick(() => {
        if (productGallery.value.length < 1) return;
        const gl = new Glide(glideEl.value, sliderOptions);
        gl.on("run", () => {
          go(gl.index);
        });
        gl.mount();
        glide.value = gl;
      });
    });

    onUpdated(() => {
      emit("init", {
        numImages: imageItems.value.length,
        numVideos: videoItems.value.length,
      });
      if (glide.value) {
        nextTick(() => {
          glide.value.mount();
        });
      }
    });

    onBeforeUnmount(() => {
      if (glide.value) {
        glide.value.destroy();
      }
    });
    return {
      activeIndex,
      imageSizes,
      galleryImgEl,
      glideEl,
      go,
      productGallery,
    };
  },
});
